module.exports = __webpack_public_path__ + "img/savology-user-personae.e4ebc9ed.png";